export default {
  status: Object.freeze({
    STATUS_NEW: 'new', STATUS_REGISTRATION: 'registration', STATUS_LAB_DELIVERY: 'lab-delivery',
    STATUS_REGISTERED: 'registered', STATUS_CLINIC_DELIVERED: 'clinic-delivered', STATUS_LAB_DELIVERED: 'lab-delivered'
  }),
}
